import { mount, unmount } from 'redom';
import {
  util,
  Path
} from 'fabric';
import {
  displayElementAroundAnchorSticky
} from 'utilities/element-position';

import CanvasShapeToolbar from 'generics/components/basic-text-editor-slate/toolbar-native/canvas-shape';

let toolbar = null;
let scrollUnlistener = null;

class ShapeToolbar {

  static show(canvas, configuration) {

    const mountPoint = canvas.parentNode.parentNode;

    if (toolbar !== null) {
      unmount(mountPoint, toolbar);
    }

    const scrollableParent = canvas.closest('.basic-text-editor-main');

    mount(mountPoint, toolbar = new CanvasShapeToolbar(buildToobarConfiguration(configuration), scrollableParent));

    const element = toolbar.el;
    const anchorElement = configuration.anchor;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = [
      'top',
      'bottom',
      'left',
      'right'
    ];

    scrollUnlistener = displayElementAroundAnchorSticky(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides, scrollableParent);

  }

  static hide(canvas) {

    const mountPoint = canvas.parentNode.parentNode;

    if (toolbar !== null) {
      unmount(toolbar.el.parentNode, toolbar);
      scrollUnlistener();
    }

    toolbar = null;

  }

}

function buildToobarConfiguration(configuration) {

  const canvas = configuration.canvas;
  const fabricCanvas = configuration.fabricCanvas;
  const activeObject = configuration.activeObject;

  function postChange() {
    fabricCanvas.renderAll();
    fabricCanvas.fire('object:modified', { target: activeObject });
  }

  const toolbarConfiguration = {
    shapeType: activeObject.type,
    anchor: configuration.anchor,
    color: {
      background: activeObject.backgroundColor
    },
    border: {
      width: activeObject.strokeWidth,
      color: activeObject.stroke
    },
    shadow: activeObject.shadow || {
      color: '', // Shadow color
      blur: 0, // Shadow blur
      offsetX: 0, // Horizontal offset
      offsetY: 0
    },
    // path: activeObject.path.join(' '),
    callbacks: {
      onBackgroundColorChange: (value) => {

        activeObject.set({ fill: value });

        postChange();
      },
      onBorderChange: (border) => {
        activeObject.set({
          strokeWidth: border.width,
          stroke: border.color
        });
        postChange();
      },
      onShadowChange: (shadow) => {
        activeObject.set({
          shadow: {
            color: shadow.color,
            blur: shadow.blur,
            offsetX: shadow.offsetX,
            offsetY: shadow.offsetY
          }
        });
        postChange();
      },
      onPathChange: (path) => {

        const newPathObject = util.parsePath(path);
        configuration.canvas.replaceActiveObject(new Path(newPathObject));

        postChange();

      },
      onMoveForward() {
        fabricCanvas.bringObjectForward(activeObject);
        postChange();
      },
      onMoveBackward() {
        fabricCanvas.sendObjectBackwards(activeObject);
        postChange();
      },
      onMoveToFront() {
        fabricCanvas.bringObjectToFront(activeObject);
        postChange();
      },
      onMoveToBack() {
        fabricCanvas.sendObjectToBack(activeObject);
        postChange();
      }
    },
    onClose() {
      canvas.enableDeleting();
    },
    onActive() {
      canvas.disableDeleting();
    },
    onInactive() {
      canvas.enableDeleting();
    },
    onDuplicate() {
      canvas.duplicateActiveObject();
    }
  };

  return toolbarConfiguration;

}

export default ShapeToolbar;